interface ValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const validatePDFFileName = (fileName: string): ValidationResult => {
  if (!fileName || fileName.length === 0) {
    return {
      isValid: false,
      errorMessage: 'Please enter file name.',
    };
  }

  if (fileName.length > 50) {
    return {
      isValid: false,
      errorMessage: 'File name must be 50 characters or less.',
    };
  }

  const validFileNameRegex = /^(?! )[a-zA-Z0-9, _@-]*$/;
  if (!validFileNameRegex.test(fileName)) {
    return {
      isValid: false,
      errorMessage:
        'Please use only letters, numbers, and the following characters: @ - _',
    };
  }

  return {
    isValid: true,
    errorMessage: '',
  };
};
